import { api } from "../../services/Api.js";
//import Vue from 'vue';

export function get_chat_messages({ commit, state }, payload ){


    // adding token
    payload.token=state.appSettings.token

  
    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    
    // return chainable promise
    return api
    .post(school,"get_chat_messages.php",payload)
    .then( result =>{
      
      commit('SET_CHAT_MESSAGES', {store_key:payload.store_key,messages:result.data});
    })
    .catch( () => {

      // lets not spawn error on this..
      //Vue.$toaster.toast("[error: action get_chat_messages]" + error);
     
    })
    

}